<app-loading type='LOADING_DATA' *ngIf="this.MedicalReports.data.api_result.Posting"></app-loading>

<div class="ui-g" *ngIf="!this.MedicalReports.data.api_result.Posting && this.MedicalReports.data.api_result.PromiseResult.success">
  <div class="ui-g-12">
    <h2 class="boldnlabel">Uploaded Medical Records</h2>

    <div *ngIf="(this.MedicalReports.data.api_result.PromiseResult?.success!=null)">
      <app-document-viewer [data]="this.MedicalReports.data.api_result"></app-document-viewer>
    </div>

  </div>
</div>

<app-error-messages [api_result]="this.MedicalReports.data.api_result"></app-error-messages>